// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { unauthenticatedHandler, } from '../../../../../clients';
import { composeTransferHandler } from '../../../../../clients/internal';
import { createDisableCacheMiddleware } from '../../../middleware';
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */
export const cognitoIdentityTransferHandler = composeTransferHandler(unauthenticatedHandler, [createDisableCacheMiddleware]);
